/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 * Paths to external routes
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.0.0
 */

import { appHistoryPush } from '@modules/app/appHistory';

export const ExternalRoutePath = {
    account: '/account/accountInfo/{0}',
    accountCollation: '/report/account/collationSum',
    accountCollationId: '/report/account/collationSum/{0}',
    accountDcRules: '/dcrules/account/basket',
    accountDcRulesId: '/dcrules/account/{0}',
    accountExpensesId: '/expenses/account',
    accountPayments: '/d/payments/account',
    accountPaymentsId: '/d/payments/account/{0}',
    accountReport: '/additionalReport/choose/account',
    accountReportId: '/additionalReport/choose/account/{0}',
    autoReport: '/d/autoreport/{0}',
    bills: '/d/bills/selection',
    billsAccount: '/d/bills/{0}',
    billsDocs: '/billsDocs/selection',
    billsDocsUnpaid: '/billsDocs/unpaid',
    billsDocsAccount: '/billsDocs/{0}',
    billsDocsAccountUnpaid: '/billsDocs/unpaid/{0}',
    billsUnpaid: '/d/bills/unpaid',
    billsUnpaidAccount: '/d/bills/unpaid/{0}',
    dashboard: '/dashboard',
    expensesAnalyzerAccountBasket: '/d/expenses/account/basket',
    expensesAnalyzerAccountId: '/d/expenses/account/{0}',
    expensesAnalyzerSubscriberFixedBasket: '/d/expenses/fixed/basket',
    expensesAnalyzerSubscriberMobileBasket: '/d/expenses/mobile/basket',
    fixedInfo: '/fixedSubscriber/info/{0}',
    fixedDetails: '/callsDetail/fixed',
    inquiry: '/d/inquiries/inquiry',
    logout: '/logout',
    mobileAdditionalAccounts: '/manageAdditionalAccounts/mobile',
    mobileAdditionalAccountsId: '/manageAdditionalAccounts/mobile/{0}',
    mobileDcRules: '/changedcrules/mobile',
    mobileDcRulesId: '/changedcrules/mobile/{0}',
    mobileDetails: '/callsDetail/mobile',
    mobileDetailsId: '/callsDetail/{0}',
    mobileExpensesDetails: '/callsDetail/expenses/subscribers',
    mobileLock: '/changelock/mobile',
    mobileLockId: '/changelock/mobile/{0}',
    mobilePersonalData: '/personalDataImport/master',
    mobilePlan: '/changepkgrateplan/mobile',
    mobilePlanId: '/changepkgrateplan/mobile/{0}',
    mobilePlanFromCampaign: '/changepkgrateplan/campaign/mobile',
    mobileReport: '/additionalReport/choose/mobile',
    mobileReportId: '/additionalReport/choose/mobile/{0}',
    mobileRole: '/changerole/mobile',
    mobileRoleId: '/changerole/mobile/{0}',
    mobileService: '/changerateservice/mobile',
    mobileServiceId: '/changerateservice/mobile/{0}',
    mobileServiceFromCampaign: '/changerateservice/campaign/mobile',
    order: '/d/order/{0}',
    subscriberFixed: '/fixedSubscriber/info',
};
export const openExternalRoute = (url: string, target = '_self'): void => {
    window.open(url, target);
};

export const openRoute = (url: string): void => {
    let ext = false;
    Object.values(ExternalRoutePath).forEach((path: string) => {
        const reg = new RegExp(path.replace('{0}', '.*'));
        if (reg.test(url)) {
            ext = true;
        }
    });
    if (ext) {
        window.location.href = url;
    } else {
        appHistoryPush(url);
    }
};

const routes = {
    ExternalRoutePath,
    openExternalRoute,
};

export default routes;
